// @ts-nocheck
import { httpClient } from '../../../core/network';

class ProductService {
  static fetchProducts(onlysupport = false) {
    const apiUrl = '/products';
    return httpClient.get(apiUrl, {
      params: { onlysupport },
    });
  }

  static fetchCompanyProducts(clientSegment, onlysupport = false) {
    const apiUrl = '/products';
    return httpClient.get(apiUrl, {
      params: { onlysupport, clientSegment },
    });
  }

  static fetchChannels() {
    const apiUrl = '/products';
    return httpClient.get(apiUrl, {
      params: { channels: true },
    });
  }

  static fetchProduct(productId) {
    const apiUrl = `/products/${productId}`;
    return httpClient.get(apiUrl);
  }

  static updateProduct(userId, subscriptionId, productId, product, force = false) {
    const apiUrl = `/users/${userId}/subscriptions/${subscriptionId}/product/${productId}`;
    return httpClient.put(apiUrl, product, {
      params: { force },
    });
  }

  static restoreProduct(userId, product) {
    const productData = {
      id: product.id,
      durationInDays: product.duration,
    };

    if (product.features) {
      productData.features = product.features;
    }

    const apiUrl = `/users/${userId}/products`;
    return httpClient.put(apiUrl, productData);
  }

  static createSupportProduct(userId, product) {
    const productData = {
      id: product.id,
      duration: product.duration,
      price: 0,
    };

    if (product.features) {
      productData.features = product.features;
    }

    const apiUrl = `/users/${userId}/products`;
    return httpClient.post(apiUrl, productData);
  }

  static resendAddonActivationLink(userId, productId) {
    const apiUrl = `/users/${userId}/products/${productId}`;
    return httpClient.get(apiUrl);
  }

  static unlinkAddons(userId, productId) {
    const apiUrl = `/users/${userId}/products/${productId}`;
    return httpClient.patch(apiUrl);
  }
}

export default ProductService;
